import { render, staticRenderFns } from "./CurrentPower.vue?vue&type=template&id=88271396&scoped=true&"
import script from "./CurrentPower.vue?vue&type=script&lang=js&"
export * from "./CurrentPower.vue?vue&type=script&lang=js&"
import style0 from "./CurrentPower.vue?vue&type=style&index=0&id=88271396&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88271396",
  null
  
)

export default component.exports